import { render, staticRenderFns } from "./LotListComponent.vue?vue&type=template&id=2652eb02&scoped=true&"
import script from "./LotListComponent.vue?vue&type=script&lang=js&"
export * from "./LotListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652eb02",
  null
  
)

export default component.exports